import React from "react";
import { ReportField } from "./ReportField";
import { Box } from "@mui/material";

interface BuildingConditionContainerProps {
  userId: string;
  propertyId: string;
}

export const BuildingConditionContainer: React.FC<
  BuildingConditionContainerProps
> = ({ userId, propertyId }) => {
  return (
    <Box sx={{ px: 6 }}>
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Building Components"
        fieldKey="buildingCondition.buildingComponents"
      />
    </Box>
  );
};
